import { observer } from "mobx-react-lite";
import React from "react";

interface IToggleSwitchProps {
    id: string;
    label: string;
    checked: boolean;
    onChange: () => void;
    disabled?: boolean;
}


const ToggleSwitch = ({ id, label, checked, onChange, disabled = false }: IToggleSwitchProps) => {
  return (
    <div className="flex flex-row items-center justify-between">
      <label htmlFor={id}>{label}</label>
      <label className="relative inline-flex items-center cursor-pointer font-medium text-[#474A51]">
        <input 
          type="checkbox" 
          id={id} 
          className="sr-only peer" 
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#383181]"></div>
      </label>
    </div>
  );
};

export default observer(ToggleSwitch);